<template>
	<h4 class="font-weight-medium mb-3">
		<slot></slot>
	</h4>
</template>

<script>
export default {
	name: "ClaimTitle"
};
</script>

<style lang="scss" scoped></style>
